import React, { useState } from 'react';
import LoadingSpinner from './LoadingSpinner';
import LoadingPage from './LoadingPage';

const LoadingDemo: React.FC = () => {
  const [showFullPage, setShowFullPage] = useState(false);

  if (showFullPage) {
    return (
      <LoadingPage 
        message="This is a full page loading demo" 
        size={300}
      />
    );
  }

  return (
    <div style={{ 
      padding: '40px', 
      fontFamily: 'Gabarito, sans-serif',
      maxWidth: '800px',
      margin: '0 auto'
    }}>
      <h1>Loading Animation Demo</h1>
      <p>This demonstrates the new loading animation using your Lottie JSON file.</p>
      
      <div style={{ marginBottom: '40px' }}>
        <h2>Small Loading Spinner (100px)</h2>
        <LoadingSpinner size={100} />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2>Medium Loading Spinner (200px)</h2>
        <LoadingSpinner size={200} />
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2>Large Loading Spinner (300px)</h2>
        <LoadingSpinner size={300} />
      </div>

      <button 
        onClick={() => setShowFullPage(true)}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer'
        }}
      >
        Show Full Page Loading
      </button>

      <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        The loading animation is now integrated into all creator landing pages. 
        It will show while the page data is being fetched from the database.
      </p>
    </div>
  );
};

export default LoadingDemo; 